import React from "react";
import { connect } from "react-redux";

import AvailableBids from "./AvailableBids";
import AvailableJobs from "./AvailableJobs";
import AvailablePurchaseOrders from "./AvailablePurchaseOrders";
import AvailableAppointments from "./AvailableAppointments";
import { fieldsSelector } from "../../redux/settings";
import FieldSettings from "../shared/Event/FieldSettings";

const AvailableEvents = ({ entity, fields }) => {
  const renderContent = () => {
    switch (entity) {
      case "bids":
        return <AvailableBids />;
      case "jobs":
        return <AvailableJobs />;
      case "purchaseOrders":
        return <AvailablePurchaseOrders />;
      case "appointments":
        return <AvailableAppointments />;

      default:
        return null;
    }
  };

  return (
    <FieldSettings.Provider value={fields}>
      {renderContent()}
    </FieldSettings.Provider>
  );
};

const mapStateToProps = (state) => ({
  entity: state.settings.entity,
  fields: fieldsSelector(state),
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AvailableEvents);
